import React from 'react';
import { IndexRedirect, Route } from "react-router";
import { checkRolePermission } from "../../libs/checkPermission";
import TabBar from '../TabBar';

import InventoryManufacturerList from './ManufacturerList';
import InventoryManufacturerModify from './ManufacturerModify';
import InventorySupplierList from './SupplierList';
import InventorySupplierModify from './SupplierModify';
import InventoryProductList from './ProductList';
import ProductRelatedFileList from './ProdctRelatedFileList';
import InventoryProductEdit from './ProductModify';
import InventoryItemList from './ItemList';
import InventoryItemEdit from './InventoryItemModify';
import InventoryPcategoryList from './PcategoryList';
import InventoryPcategoryModify from './PcategoryModify';
import ProductRelatedFileAdd from "./ProductRelatedFileAdd";

const Home = props => {
  return (
    <div className='inner-section-root'>
      <TabBar
        items={[
          { to: '/inventory/manufacturer', label: 'Manufacturer' },
          { to: '/inventory/supplier', label: 'Supplier' },
          { to: '/inventory/pcategory', label: 'Product Category' },
          { to: '/inventory/product', label: 'Product' },
          { to: '/inventory/item', label: 'Item' },
        ]}
      />
      <div className='inner-section-content'>
        {props.children}
      </div>
    </div>
  );
};

export const InventoryRoutes = () => (
  <Route component={Home}>
    <IndexRedirect to="/inventory/manufacturer" />
    <Route path="manufacturer" component={checkRolePermission(InventoryManufacturerList)} name='view inventory'>
      <Route path=":id" component={checkRolePermission(InventoryManufacturerModify)} name='modify inventory' />
    </Route>
    <Route path="supplier" component={checkRolePermission(InventorySupplierList)} name='view inventory'>
      <Route path=":id" component={checkRolePermission(InventorySupplierModify)} name='modify inventory' />
    </Route>
    <Route path="product" component={checkRolePermission(InventoryProductList)} name='view inventory'>
      <Route path=":id/files" components={{ main: checkRolePermission(ProductRelatedFileList) }} name='modify inventory'>
        <Route path='add' component={checkRolePermission(ProductRelatedFileAdd)} />
      </Route>
      <Route path=":id" component={checkRolePermission(InventoryProductEdit)} name='modify inventory' />
    </Route>
    <Route path="item" component={checkRolePermission(InventoryItemList)} name='view inventory'>
      {/* <Route path="add" component={checkRolePermission(InventoryItemAdd)} name='modify inventory' /> */}
      <Route path=":id" component={checkRolePermission(InventoryItemEdit)} name='modify inventory' />
    </Route>
    <Route path="pcategory" component={checkRolePermission(InventoryPcategoryList)} name='view inventory'>
      <Route path=":id" component={checkRolePermission(InventoryPcategoryModify)} name='modify inventory' />
    </Route>
  </Route>
)


// WEBPACK FOOTER //
// ./src/components/Inventory/routes.js